class VariantSelectsAirMat extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.getAvailableVariant(event);
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (!this.closest("floated-form")) {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.resetProductFormState();
      this.renderProductInfo();
    }
  }

  getAvailableVariant(event) {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      let fixedOptionValue;
      const fieldsets = this.querySelectorAll("fieldset");

      if (event.target.tagName == "SELECT") {
        fixedOptionValue =
          event.target.options[event.target.selectedIndex].value;
      } else if (event.target.tagName == "INPUT") {
        fixedOptionValue = event.target.value;
      }

      fieldsets.forEach((fieldset, index) => {
        const select = fieldset.querySelector('select[name^="options"]');
        const radio = fieldset.querySelector(
          `input[type="radio"][value="${encodeURIComponent(fixedOptionValue)}"]`
        );

        if (select) {
          if (select.name.includes(event.target.name)) {
            this.fixedSelectIndex = index;
          }
        } else if (radio) {
          this.fixedSelectIndex = index;
        }
      });

      const fixedOptionValues = Array.from(fieldsets)
        .slice(0, this.fixedSelectIndex + 1)
        .map((fieldset) => {
          const select = fieldset.querySelector('select[name^="options"]');
          if (select) {
            return select.options[select.selectedIndex].value;
          }
          const radioSelected = fieldset.querySelector(
            'input[type="radio"]:checked'
          );
          if (radioSelected) {
            return radioSelected.value;
          }
          return null;
        })
        .filter((value) => value !== null);

      this.availableVariant = this.getVariantData().find(
        (variant) =>
          variant.available &&
          fixedOptionValues.every(
            (value, index) => variant[`option${index + 1}`] === value
          )
      );

      if (!this.availableVariant) {
        this.availableVariant = this.getVariantData().find(
          (variant) =>
            variant.available &&
            variant[`option${this.fixedSelectIndex + 1}`] === fixedOptionValue
        );
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });

      if (
        (!this.currentVariant || !this.currentVariant?.available) &&
        this.availableVariant
      ) {
        this.currentVariant = this.availableVariant;

        const fieldsets = this.querySelectorAll("fieldset");

        fieldsets.forEach((fieldset, index) => {
          const optionValue = this.currentVariant[`option${index + 1}`];
          const select = fieldset.querySelector('select[name^="options"]');
          const radioToSelect = fieldset.querySelector(
            `input[type="radio"][value="${optionValue}"]`
          );

          if (index != this.fixedSelectIndex) {
            if (select) {
              select.value = optionValue;
            } else if (radioToSelect) {
              radioToSelect.checked = true;
            }
          }
        });
      }
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    // const swiperWrappers = document.querySelectorAll(".product__media-wrapper");
    // swiperWrappers.forEach((elem) => {
    //   if (!this.isHidden(elem)) {
    //     const newMedia = elem.querySelector(
    //       `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    //     );

    //     if (elem.querySelector(".js-media-list")) {
    //       elem
    //         .querySelector(".js-media-list")
    //         .swiper.slideTo(
    //           elem
    //             .querySelector(".js-media-list")
    //             .swiper.slides.indexOf(newMedia)
    //         );
    //     }
    //   }
    // });

    updateProductSwiper();
  }

  updateURL() {
    if (!this.classList.contains("featured-product-radios")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant) return;
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        const colorNameSource = html.getElementById(
          `ColorName-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const colorNameDestination = document.getElementById(
          `ColorName-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }
        if (colorNameSource && colorNameDestination)
          colorNameDestination.innerHTML = colorNameSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  resetProductFormState() {
    const productForm = document
      .getElementById(`product-form-${this.dataset.section}`)
      .closest("product-form");
    if (productForm) {
      const quantity = productForm.querySelector("quantity-input");
      if (quantity) quantity.input.value = 1;
      productForm?.handleErrorMessage();
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects-air-mat", VariantSelectsAirMat);

class VariantRadiosAirMat extends VariantSelectsAirMat {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define(
  "variant-radios-air-mat",
  VariantRadiosAirMat
)

function updateProductSwiper() {
  // 找到当前的颜色
  const currentColor = $(".product-form__controls-group input:checked:eq(1)").val();
  const currentSize = $(".product-form__controls-group input:checked:eq(0)").val();

  // B G PK 是颜色
  // 04 11 01 是尺寸
  const colorMap = {
    Green: "G",
    Black: "B",
    Pink: "PK",
  };
  const sizeMap = {
    "10ft*3.3ft*4in (3*1*0.1m)": "01",
    "13ft*3.3ft*4in (4*1*0.1m)": "04",
    "16ft*3.3ft*4in (5*1*0.1m)": "11",
  };
  const filterStr = "YOGA" + sizeMap[currentSize] + colorMap[currentColor] + "-";

  const filterFunction = (slide) => {
    return slide.dataset.mediaSrc.includes(filterStr);
  }
  // 缩略图 preview_image
  window.productPreviewSwiper.removeAllSlides();
  window.productPreviewSwiper.appendSlide(
    window.productPreviewAllSlides.filter(filterFunction) 
  );

  // popup
  window.productPopupSwiper.removeAllSlides();
  window.productPopupSwiper.appendSlide(
    window.productPopupAllSlides.filter(filterFunction)
  );

  // 主图
  window.productSwiper.removeAllSlides();
  window.productSwiper.appendSlide(
    window.productAllSlides.filter(filterFunction)
  );
  setTimeout(() => {
    window.productSwiper.slideTo(0);
  }, 500);
}

(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);

    // 主图swiper
    window.productSwiper = document
      .querySelectorAll(".product__media-wrapper")[0]
      .querySelector(".js-media-list").swiper;
    window.productAllSlides = productSwiper.slides;

    // popup swiper
    window.productPopupSwiper = document.querySelector(".js-popup-slider").swiper;
    window.productPopupAllSlides = productPopupSwiper.slides;

    // 缩略图 preview_image
    window.productPreviewSwiper = document
      .querySelectorAll(".product__media-wrapper")[0]
      .querySelector(".js-media-sublist").swiper;
    window.productPreviewAllSlides = productPreviewSwiper.slides;

    updateProductSwiper();
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();
})();
